import React, { Fragment, useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../../../components/BackButton";
import { getLabel } from "../../../../hooks/use-labels";
import SupplierRating from "../../../Home/Components/SupplierRating";
import { fetchSupplierReviews } from "../../api-handler";
import ImageRowContainer from "../../../../components/ImageRowContainer";
import ComponentWithAdds from "../../../../components/ComponentWithAdds";
import {
  prepareReviewList,
  setColSize1,
  setColSize2,
} from "./supplier-review-utils";
import HexLoader from "../../../../components/HexLoader";
import ContainerBox from "../../../../components/ContainerBox";
import "./styles.css";
import List from "./List";
import HexInfiniteScroll from "../../../../components/HexInfiniteScroll";
import ResizeWrapper from "../../../../components/ResizeWrapper";

const SupplierReviewList = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { supplier, link } = location.state;

  const [loading, setLoading] = useState(true);
  const [reviewList, setReviewList] = useState([]);
  const [last, setLast] = useState(false);
  const [pagination, setPagination] = useState({
    size: 5,
    page: 0,
    last: false,
  });

  useEffect(() => {
    getSupplierReviews(id, pagination);
  }, [id, pagination]);

  const getSupplierReviews = (id, pagination) => {
    const requestParams = {
      supplierId: id,
      active: true,
      ...pagination,
      sort: "id,ASC",
    };

    fetchSupplierReviews(requestParams)
      .then(({ data }) => {
        setReviewList(prepareReviewList(data));
        setLast(data.last);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleScroll = () => {
    setPagination((prev) => ({ ...prev, size: prev.size + 3 }));
  };

  if (loading) return <HexLoader />;

  return (
    <ResizeWrapper
      render={(resizeWidth) => (
        <Fragment>
          <BackButton
            text={getLabel("backLabel")}
            onClick={() => navigate(link)}
          />

          <ComponentWithAdds
            className="supplier-review-container"
            componentFirst={
              <Fragment>
                <ImageRowContainer
                  colsize1={setColSize1(resizeWidth)}
                  colsize2={setColSize2(resizeWidth)}
                  titleClass="font-24-bold-500"
                  className="supplier-rating-row"
                  props={{
                    imgSrc: `${supplier.referenceUrlLogo}?size=xs`,
                    title: supplier.name,
                    subTitle: (
                      <SupplierRating
                        rating={supplier.avgRating}
                        outOf={true}
                        hideTextRating={true}
                      />
                    ),
                  }}
                />

                <HexInfiniteScroll
                  data={reviewList}
                  onScroll={handleScroll}
                  hasMore={!last}
                  maxHeight={700}
                  height="auto"
                  className="supplier-review-list-scrolling"
                >
                  <ContainerBox className="review-list-container-box">
                    <List reviewList={reviewList} resizeWidth={resizeWidth} />
                  </ContainerBox>
                </HexInfiniteScroll>
              </Fragment>
            }
          />
        </Fragment>
      )}
    />
  );
};

export default SupplierReviewList;
